import $ from 'jquery';
window.$ = window.jQuery = $;
import 'slick-carousel'
$( '.testimonials__carousel' ).slick(
	{
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		arrows: true,
	}
);
